






























































import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { AuthParams } from '../models/userdata/authparams';
import { Company } from '../models/company/companyprofile';
import { ATSJobListParams } from '../models/jobs/atsjoblistparams';
import router from '../router';
import VideoPlayer from '@/components/Commons/VideoPlayer.vue';

@Component({
  name: 'CompanyReferral',
  components: {
    VideoPlayer,
  },
})
export default class CompanyReferral extends Vue {
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private address: string = '';
  private map: string = '';

  parseUrl(videoURL: string): string {
    const nArr = videoURL.split('=');
    return nArr[1];
  }
  get adminMessage() {
    return vxm.referrals.ReferralWrapper.referralEventDescription;
  }

  get isLocationEnabled() {
    const latitude = vxm.jobs.latitude;
    const longitude = vxm.jobs.longitude;
    if (longitude && longitude) {
      return true;
    } else {
      return false;
    }
  }
  searchJobs() {
    this.jobListParams.resultPage = 1;
    this.jobListParams.resultSize = 10;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.filter.radius = this.companyInfoData[0].radius;
    vxm.jobs.reloadJobs(this.jobListParams).then(() => {
      router.push({ name: 'Findjobs' });
    });
  }

  get companyInfoData(): Company[] {
    const cInfo: Company[] = [];
    cInfo.push(vxm.jobs.CompanyInfo);
    return cInfo;
  }
  mounted() {
    const referralCode = vxm.referrals.ReferralWrapper.referralCode;
    const companyCode = vxm.jobs.CompanyInfo;
    const isMobileDevice = vxm.utility.isMobileDevice;
    const mobileAppsessionToken =
      this.$route.query.mobileAppsessionToken !== 'undefined'
        ? this.$route.query.mobileAppsessionToken
        : '';

    const iOSfallback =
      this.$route.query.fallback !== undefined
        ? this.$route.query.fallback
        : '';
    const fallback = iOSfallback === 'iOS' ? false : true;

    console.log('isMobileDevice', isMobileDevice);
    const iOS = vxm.utility.isIos;
    console.log('iOS', iOS);
    let appurl = '';

    if (iOS) {
      if (fallback) {
        appurl = (<any>window).location.href + '?fallback=iOS';
        vxm.utility.iphoneURLCall(appurl);
      }
    }
    const parent: any = this.$parent.$parent;
    parent.fullViewPage = false;
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
  getCompanyDistanceUnits(): string {
    return vxm.jobs.getCompanyDistanceUnit;
  }
}
// tslint:disable-next-line:semicolon
